import { TranslateService } from '@ngx-translate/core';
import * as Domain from '@core/Domain';

export class DomainIit {

  static Init(translateService: TranslateService) {
const domain_LocalResourcesDefinition = new Domain.Domain_LocalResourcesDefinition(translateService);
const globalResourcesDefinition = new Domain.GlobalResourcesDefinition(translateService);
const requestHelper = new Domain.RequestHelper(translateService);
const userAccount = new Domain.UserAccount(translateService);
const leavesRequestHelper = new Domain.LeavesRequestHelper(translateService);
const personalInfoRequestHelper = new Domain.PersonalInfoRequestHelper(translateService);
const employeeApiResponse = new Domain.EmployeeApiResponse(translateService);
const overtimeRequestHelper = new Domain.OvertimeRequestHelper(translateService);
const employeeRequestHelper = new Domain.EmployeeRequestHelper(translateService);
const employee = new Domain.Employee(translateService);
const address = new Domain.Address(translateService);
const country = new Domain.Country(translateService);
const region = new Domain.Region(translateService);
const relationshipDto = new Domain.RelationshipDto(translateService);
const militaryObligationsDto = new Domain.MilitaryObligationsDto(translateService);
const interviewDTO = new Domain.InterviewDTO(translateService);
const foreignLanguangeDTO = new Domain.ForeignLanguangeDTO(translateService);
const institutionDTO = new Domain.InstitutionDTO(translateService);
const instDtO = new Domain.InstDtO(translateService);
const langDTO = new Domain.LangDTO(translateService);
const employeeDataChangeRequest = new Domain.EmployeeDataChangeRequest(translateService);
const employeeLeaveRequest = new Domain.EmployeeLeaveRequest(translateService);
const employeeLeave = new Domain.EmployeeLeave(translateService);
const leaveRule = new Domain.LeaveRule(translateService);
const employeeContract = new Domain.EmployeeContract(translateService);
const holiday = new Domain.Holiday(translateService);
const calendarEvent = new Domain.CalendarEvent(translateService);
const notification = new Domain.Notification(translateService);
const pendingTask = new Domain.PendingTask(translateService);
const payrollDTO = new Domain.PayrollDTO(translateService);
const payrollRequestHelper = new Domain.PayrollRequestHelper(translateService);
const sHRDashboardDTO = new Domain.SHRDashboardDTO(translateService);
const sHRDailyLeaveDTO = new Domain.SHRDailyLeaveDTO(translateService);
const treeNode = new Domain.TreeNode(translateService);
const department = new Domain.Department(translateService);
const contactDetails = new Domain.ContactDetails(translateService);
const overtimeRequest = new Domain.OvertimeRequest(translateService);
const employeeOvertimeHoursDTO = new Domain.EmployeeOvertimeHoursDTO(translateService);
const applicationUserAction = new Domain.ApplicationUserAction(translateService);
const applicationUserExternalProfile = new Domain.ApplicationUserExternalProfile(translateService);
const applicationSetting = new Domain.ApplicationSetting(translateService);
const applicationUser = new Domain.ApplicationUser(translateService);
const applicationRole = new Domain.ApplicationRole(translateService);
const applicationOperation = new Domain.ApplicationOperation(translateService);
const applicationPermission = new Domain.ApplicationPermission(translateService);
const applicationClient = new Domain.ApplicationClient(translateService);
const applicationUserLogin = new Domain.ApplicationUserLogin(translateService);
const applicationUserClaim = new Domain.ApplicationUserClaim(translateService);
const profileSetting = new Domain.ProfileSetting(translateService);
const profile = new Domain.Profile(translateService);
const applicationLanguage = new Domain.ApplicationLanguage(translateService);
const applicationTimezoneInfo = new Domain.ApplicationTimezoneInfo(translateService);
const dateTimeFormat = new Domain.DateTimeFormat(translateService);
const applicationTheme = new Domain.ApplicationTheme(translateService);
const fileData = new Domain.FileData(translateService);
const auditEntityConfiguration = new Domain.AuditEntityConfiguration(translateService);
const auditPropertyConfiguration = new Domain.AuditPropertyConfiguration(translateService);
const auditLogEntry = new Domain.AuditLogEntry(translateService);
const auditLogEntryType = new Domain.AuditLogEntryType(translateService);
const auditLogPropertyActionType = new Domain.AuditLogPropertyActionType(translateService);
const workflowExecutionResult = new Domain.WorkflowExecutionResult(translateService);
const workflowContextBase = new Domain.WorkflowContextBase(translateService);
const workflowSchedule = new Domain.WorkflowSchedule(translateService);
 }

}
